var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "column-layout" }, [
    _c(
      "div",
      { staticClass: "table-layout" },
      [
        _c(
          "el-table",
          {
            staticStyle: { width: "100%" },
            attrs: { data: _vm.fileBizRecList, border: "" }
          },
          [
            _c("el-table-column", {
              attrs: {
                prop: "comName",
                label: "公司名称",
                width: "200",
                align: "left"
              }
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: {
                prop: "dispName",
                label: "显示名称",
                width: "200",
                align: "left"
              }
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: {
                prop: "extName",
                label: "扩展名称",
                width: "100",
                align: "left"
              }
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: {
                prop: "byteSize",
                label: "文件大小（字节）",
                width: "120",
                align: "right"
              }
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: {
                prop: "md5",
                label: "MD5码",
                width: "280",
                align: "center"
              }
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: { prop: "uuid", label: "UUID", align: "center" }
            })
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-bc5d3eac", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bc5d3eac","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/ctrl/RepoFileBizRec.vue
// module id = 2161
// module chunks = 0